import { render, staticRenderFns } from "./purchaseDelivery.vue?vue&type=template&id=417184d2"
import script from "./purchaseDelivery.vue?vue&type=script&lang=js"
export * from "./purchaseDelivery.vue?vue&type=script&lang=js"
import style0 from "./purchaseDelivery.vue?vue&type=style&index=0&id=417184d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports